var map = {
	"./avatar.png": 308,
	"./calendar.png": 165,
	"./elips.png": 596,
	"./home.png": 553,
	"./logo.png": 949,
	"./logout.png": 645,
	"./notifications.png": 64,
	"./piechart.png": 178,
	"./reports.png": 40,
	"./settings.png": 957,
	"./trophy.png": 826,
	"./wallet.png": 626,
	"./wave.png": 461
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;